import EventService from "./event-service";
import UserControlService from "./user-control-service";

export default class ShortcutService {

    private static isInitialized: boolean = false;
    private static eventBus : EventService = new EventService();

    static initialize() {
        if (this.isInitialized) {
            return;
        }

        document.addEventListener("keydown", (event) => {
            if (event.repeat) return;

            // Add new shortcuts in here
            if (event.ctrlKey && event.key === "z") {
                UserControlService.undo();
            }

            if (event.ctrlKey && event.key === "y") {
                UserControlService.redo();
            }

            if (event.ctrlKey && event.key === "s") {
                event.preventDefault();
                UserControlService.save();
            }
        });

        this.isInitialized = true;
    }
}